const invoiceDetailsConstantsEN = {
  invoiceTitle: 'Order Slip',
  invoiceBreadcrumb: 'ORDER SLIP',
  invoiceSubtitle: 'Thanks for doing your business with Sayma',
  invoiceNumber: 'Slip #:',
  invoiceDate: 'Slip date:',
  invoiceBillTo: 'Bill to',
  invoiceFrom: 'From',
  invoiceFromSayma: 'The Sayma',
  invoiceTableVideoTitleColumn: 'VIDEO TITLE',
  invoiceTablePriceColumn: 'PRICE',
  invoiceSubtotal: 'Sub-total',
  invoiceTaxes: 'Taxes',
  invoiceTotalAmount: 'Total amount',
  discountAmount: ' Discount',
};

export default invoiceDetailsConstantsEN;
